import { LegacyPagePaths } from "App/routes/paths";
import { lazyWithRetries } from "Utils/LazyWithRetries/LazyWithRetries";

import { orchestrationPathResources } from "../../orchestrationPaths";
import CampaignsRouter, { CampaignsRerouter } from "../CampaignsRouter";
import { CampaignsPaths } from "../paths";

import type { RegalRouteObject } from "App/routes/types";

const CampaignsGridPage = lazyWithRetries("Campaigns page", () => import("./CampaignsGridPage/CampaignsGridPage"));
const CampaignEditPage = lazyWithRetries("Edit campaign page", () => import("./CampaignsEditPage/CampaignsEditPage"));

export const campaignsRoute: RegalRouteObject = {
    path: `/${orchestrationPathResources.campaigns}`,
    element: <CampaignsRouter />,
    hasNestedRoutes: true,
    children: [
        {
            index: true,
            element: <CampaignsGridPage />,
        },
        {
            path: CampaignsPaths.editDashboard,
            element: <CampaignEditPage />,
        },
        {
            path: CampaignsPaths.edit,
            element: <CampaignEditPage />,
        },
    ],
};

export const rerouteCampaignsRoute: RegalRouteObject = {
    path: LegacyPagePaths.campaigns,
    element: <CampaignsRerouter />,
    children: [
        {
            path: "*",
            element: <CampaignsRerouter />,
        },
    ],
};
